import { Colors } from "src/styles/DesignSystem";
import styled from "styled-components";

import bgFooter from 'src/assets/bg-footer.png';

export const FooterContainer = styled.section`
    width: 100%;

    display: flex;
    flex-wrap: wrap;
    /* flex-direction: column; */

    background: no-repeat ${props => props.bgColor} url(${bgFooter});
    background-size: cover;

    @media screen and (min-width: 320px) and (max-width: 480px){
		background-size: 165% 80%;
        padding-top: 10%;
	}
`;

export const FooterContent = styled.footer`
    width: 85%;
    padding-top: 1rem;
    background-color: ${Colors.white};
    border-radius: 20px 20px 0 0;

    font: 0.85rem / 1.2 "Varela Round", arial, sans-serif;
    color: ${Colors.grey};

    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-self: flex-end;
    justify-content: space-evenly;

    @media screen and (min-width: 320px) and (max-width: 480px){
        width: 100%;
    }
`;

export const FooterLogo = styled.figure`
    width: 5%;
    img{
        width: 100%;
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        width: 15%;
    }
`;

export const FooterLocal = styled.p`
    @media screen and (min-width: 320px) and (max-width: 480px){
        width: 65%;
    }
`;

export const FooterHorarios = styled.article`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 35%;

    p{
        &:nth-child(2){
            margin: 0 7.5%;
        }
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        margin: 1.5rem 0;
        width: 100%;
    }
`;

export const SocialIcons = styled.aside`
    display: flex;
    align-items: center;

    cursor: pointer;

    a{
        width: 20px;
        display: flex;
        align-items: center;
        justify-content: center;

        svg{
            width: 100%;
            fill: ${Colors.brown};
        }

        &:nth-child(2){
            margin: 0 1rem;
        }

        &:first-child{
            svg{
                width: 12px;
            }
        }
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        width: 100%;
        margin-left: 10%;
    }
`;

export const FooterDetails = styled.aside`
    width: 100%;
    padding: .5rem 3.5rem;
    margin-top: 1rem;
    background-color: ${Colors.lighBrown};

    display: flex;
    align-items: center;
    justify-content: space-between;

    article{
        width: 45%;
        span{
            margin: 0 3%;
        }
    }

    a{
        width: 25px;
        svg path{
            fill: ${Colors.brown};
        }
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        padding: 1rem;
        article{
            width: 75%;
        }
    }
`;